<template>
  <div class="fts-user">
    <!-- <div style="background: skyblue;">
      <div>field username: {{formData[`${item.fieldName}Username`]}}</div>
      <div>field: {{formData[item.fieldName]}}</div>
      <div>field id: {{formData[`${item.fieldName}Id`]}}</div>
      <div>allowOther: {{item.allowOther}}</div>
      <div>canAddNew: {{item.canAddNew}}</div>
    </div> -->
    <v-select
      :append-to-body="appendToBody"
      :calculate-position="withPopper"
      :label="label"
      :options="list"
      :searchable="!item.optionList"
      :filterable="true"
      :allow-other="false"
      :multiple="multiple"
      :can-add-new="item.canAddNew"
      :search-field="item.custom? 'optionName' : item.searchField"
      @input="trigger()"
      @search="onSearch"
      @search:blur="$emit('blur')"
      @keyUpdate="updateKey"
      @idUpdate="updateId"
      @textUpdate="updateText"
      :text="formData[item.fieldName]"
      :key-property="'username'"
      v-model="formData[item.fieldName + 'Model']"
      ref="scroll"
      max-height="200px"
      :placeholder="'Please select one'"
      :style="{
        'width': this.width
      }"
    >
      <!-- Selected Option -->
      <div
        slot="selected-option"
        class="user-selected-option"
        @click="onFocus()">
        <fts-profile :userName="formData[item.fieldName]" :userList="users" v-if="infoTypeUsername" :key="formData[item.fieldName]">
          <div slot="profileName" slot-scope="{userProfileUsername}">
            {{userProfileUsername}}
          </div>
        </fts-profile>

        <div v-else-if="!formData[item.fieldName + 'Username']">
          {{formData[item.fieldName]}}
        </div>

        <fts-profile :userName="formData[item.fieldName + 'Username']" :userList="users" v-else>
          <div slot="profileName">{{formData[item.fieldName]}}</div>
        </fts-profile>
      </div> 
      <!-- Option -->
      <template #option="option">
        <fts-profile :userName="option.username" :profilePhotoSize="25" :userList="users" :key="option.username">
          <div slot="profileName" slot-scope="{userProfileName, userProfileUsername}" class="fts-user__profile-name">
            <template v-if="option.optionName">{{option.optionName}}</template>
            <template v-else>
              <div class="profile-name">{{userProfileName}}</div>
              <div class="profile-username">{{userProfileUsername}}</div>
            </template>
          </div>
        </fts-profile>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "../vue-select-user/index";
import { createPopper } from '@popperjs/core';

import { classificationStore } from "../store/classificationStore";

import FTSProfile from "../elements/FTSProfile";

export default {
  props: {
    item: Object,
    formData: Object,
    appendToBody: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    width: String,
    userList: Array,
  },
  components: {
    "v-select": vSelect,
    "fts-profile": FTSProfile,
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    label() {
      if (this.userList || this.infoTypeUsername) {
        return 'username';
      } else if (this.item && this.item.connectionId) {
        if (this.item.connectionField === "DocumentId")
          return "documentId";
        else if (this.item.connectionField === "Username")
          return "username"
        else if (this.item.displayProperty)
          return this.item.displayProperty
        else 
          return "optionName";
      } else {
        return "name";
      }
    },
    template: function () {
      if (this.item) return this.item.displayTemplate;
      return "";
    },
    baseServer() {
      return classificationStore.state.baseServer;
    },
    users() {
      return classificationStore.state.users.map(x => {
        if (!x.username)
          x.username = x.userName   

        return x
      }).filter(y => y.username !== "everyone" && y.username !== "involved")
    },
    infoTypeUsername() {
      return this.item.type == 19 /* username */
    }
  },
  mounted() {
    if (this.item.options) {
      this.list = this.item.optionList;
    }
  },
  methods: {
    withPopper (dropdownList, component, {width}) {
      /* set style */
      dropdownList.style.width = width;
      /* create popper */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({state}) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          }]
      });
      /* destory popper */
      return () => popper.destroy();
    },
    trigger() {
      this.$emit("input");
      if (!this.infoTypeUsername) {
        this.$emit("username", this.formData[this.item.fieldName + "Username"]);
      } else {
        this.$emit("username", this.formData[this.item.fieldName]);
      }
    },
    onFocus() {
      let input = this.$refs.scroll.$el.querySelector("input");
      input.focus();
    },
    updateKey(item) {
      console.info("[FTSUser] updateKey", item)
      if (!this.infoTypeUsername && item) {
        this.$set(this.formData, `${this.item.fieldName}Username`, item);
      } else {
        if (this.formData[`${this.item.fieldName}Username`])
          this.$delete(this.formData, `${this.item.fieldName}Username`);
        if (this.formData[`${this.item.fieldName}Id`])
          this.$delete(this.formData, `${this.item.fieldName}Id`);
        if (this.formData[this.item.fieldName] && !this.item.allowOther)
          this.$delete(this.formData, this.item.fieldName);
      }
    },
    updateId(item) {
      if (item)
        this.$set(this.formData, `${this.item.fieldName}Id`, item);
      else if (this.formData[`${this.item.fieldName}Id`])
        this.$delete(this.formData, `${this.item.fieldName}Id`);
    },
    updateText(item) {
      if (item)
        this.$set(this.formData, this.item.fieldName, item);
      else if (this.formData[this.item.fieldName])
        this.$delete(this.formData, this.item.fieldName);
    },
    onSearch(search, loading, pageNumber, loadingMore) {
      if (this.item.optionList != null) {
        loading = false;
        this.list = this.item.optionList;
      } else if (this.userList) {
        this.list = this.userList;
      } else if (this.item.type == 19) {
        this.list = this.users
      } else {
        console.log("querying...");
        if (pageNumber == 0) loading(true);
        else loadingMore(true);
        this.search(loading, search, this, pageNumber, loadingMore);
      }
    },
    search: _.debounce((loading, search, vm, pageNumber, loadingMore) => {
      var dataToPassIn = {},
        lineDataToPassIn = {};
      if (classificationStore) {
        var originalFormData = classificationStore.state.formData;
        if (vm.item.autoCompleteFormDataFields && originalFormData) {
          _.each(vm.item.autoCompleteFormDataFields.split(","), function (
            field
          ) {
            dataToPassIn[field] = originalFormData[field];
            lineDataToPassIn[field] = vm.formData[field];
          });
        }

        var referenceModuleId = null;

        if (vm.item.reference && vm.item.referenceModuleField) {
          loadingMore(false);
          //pass in referene
          referenceModuleId =
            originalFormData[vm.item.referenceModuleField + "Id"];

          if (!referenceModuleId) {
            referenceModuleId =
              vm.formData[vm.item.referenceModuleField + "Id"];
          }
        }
      }

      let queryPayload = {
        text: search,
        currentPage: pageNumber,
        pageSize: 10,
        fieldId: vm.item.id,
        activityId: classificationStore.state.activityId,
        vectorId: classificationStore.state.vectorId,
        documentId: classificationStore.state.documentId,
        reference: referenceModuleId,
        locusId: vm.locusId,
        formData: dataToPassIn,
        data: lineDataToPassIn
      };

      classificationStore.dispatch("searchEntry", queryPayload).then(
        (res) => {
          loading(false);
          loadingMore(false);
          if (pageNumber == 0) {
            if (vm.$refs.scroll && vm.$refs.scroll.numberOfPageLoaded) {
              vm.$refs.scroll.numberOfPageLoaded = 0;
            }
            vm.list = res.data;
          } else {
            vm.list = vm.list.concat(res.data);
          }
        },
        (error) => {
          loading(false);
          loadingMore(false);
          console.error(error);
          console.warn(
            "Got nothing from server. Prompt user to check internet connection and try again"
          );
        }
      );
    }, 350),
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-user__profile-name {
  display: flex;
  align-items: center;
  margin-left: .275rem;
  .profile-username {
    margin-left: .375rem;
    color: var(--fts-gray-5);
  }
}
</style>
